import axios from "axios";
import Swal from "sweetalert2";

export const getWorkingdays = async () => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const selectedStore = JSON.parse(
      localStorage.getItem("selectedStore")
    );
    const storeId = selectedStore?.id;
    const { data } = await axios.get(
      `/v1/admin/workingdays?store_id=${storeId}`,
      {
        headers: {
          Authorization: "Bearer " + brear,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateWorkingdays = async (postData,id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/stores/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};